/**
 * OVERRIDE LanguageSelector.jsx
 */

import LanguageSelector from '../../../../components/LanguageSelector/LanguageSelector';

export default LanguageSelector;